module.exports = __webpack_public_path__ + "img/activity_invite.96b446f4.png";